export const STORE_CATEGORIES = [
  {
    id: 'Office',
    label: 'Office',
    subcategories: [
      { id: 'ExecutiveDesks', label: 'Executive Desks' },
      { id: 'Cabinets', label: 'Cabinets' },
      { id: 'Visitorschairs', label: 'Visitors Chairs' },
      { id: 'Swivelchairs', label: 'Swivel Chairs' },
      { id: 'Otheroffice', label: 'Other Office' },
    ],
  },
  {
    id: 'Lounge',
    label: 'Lounge',
    subcategories: [
      { id: 'Coffetables', label: 'Coffee Tables' },
      { id: 'Sofas', label: 'Sofas' },
      { id: 'PlasmaStands', label: 'Plasma Stands' },
      { id: 'OtherLounge', label: 'Other Lounge' },
    ],
  },
  {
    id: 'Bedroom',
    label: 'Bedroom',
    subcategories: [
      { id: 'Beds', label: 'Beds' },
      { id: 'Suites', label: 'Bedroom Suites' },
      { id: 'Wadrobes', label: 'Wardrobes' },
      { id: 'OtherBedroom', label: 'Other Bedroom' },
    ],
  },
  {
    id: 'Kitchen',
    label: 'Kitchen',
    subcategories: [
      { id: 'Stoves', label: 'Stoves' },
      { id: 'Microwaves', label: 'Microwaves' },
      { id: 'KitchenChairsUnits', label: 'Kitchen Units' },
      { id: 'Fridges', label: 'Fridges' },
      { id: 'OtherKitchen', label: 'Other Kitchen' },
    ],
  },
  {
    id: 'Electricals',
    label: 'Electricals',
    subcategories: [
      { id: 'Tvs', label: 'TVs' },
      { id: 'Phones', label: 'Phones' },
      { id: 'OtherElectricals', label: 'Other Electricals' },
    ],
  },
  {
    id: 'Dining',
    label: 'Dining',
    subcategories: [{ id: 'Dining', label: 'Dining' }],
  },
  {
    id: 'School',
    label: 'School',
    subcategories: [{ id: 'Schoolfurniture', label: 'School Furniture' }],
  },
];

/** Old route path → store query params (for redirects) */
export const LEGACY_STORE_REDIRECTS = {
  '/Office': { category: 'Office' },
  '/Lounge': { category: 'Lounge' },
  '/Bedroom': { category: 'Bedroom' },
  '/Kitchen': { category: 'Kitchen' },
  '/Electricals': { category: 'Electricals' },
  '/Dining': { subcategory: 'Dining' },
  '/school': { subcategory: 'Schoolfurniture' },
  '/School': { subcategory: 'Schoolfurniture' },
  '/Beds': { category: 'Bedroom', subcategory: 'Beds' },
  '/Cabinets': { category: 'Office', subcategory: 'Cabinets' },
  '/Coffetables': { category: 'Lounge', subcategory: 'Coffetables' },
  '/ExecutiveDesks': { category: 'Office', subcategory: 'ExecutiveDesks' },
  '/Fridges': { category: 'Kitchen', subcategory: 'Fridges' },
  '/KitchenChairsUnites': { category: 'Kitchen', subcategory: 'KitchenChairsUnits' },
  '/OtherBedroom': { category: 'Bedroom', subcategory: 'OtherBedroom' },
  '/Otheroffice': { category: 'Office', subcategory: 'Otheroffice' },
  '/OtherOffice': { category: 'Office', subcategory: 'Otheroffice' },
  '/OtherElectricals': { category: 'Electricals', subcategory: 'OtherElectricals' },
  '/OtherKitchen': { category: 'Kitchen', subcategory: 'OtherKitchen' },
  '/OtherLounge': { category: 'Lounge', subcategory: 'OtherLounge' },
  '/otherlounge': { category: 'Lounge', subcategory: 'OtherLounge' },
  '/Stoves': { category: 'Kitchen', subcategory: 'Stoves' },
  '/Suites': { category: 'Bedroom', subcategory: 'Suites' },
  '/TVs': { category: 'Electricals', subcategory: 'Tvs' },
  '/Tvs': { category: 'Electricals', subcategory: 'Tvs' },
  '/Wadrobes': { category: 'Bedroom', subcategory: 'Wadrobes' },
  '/Wardrobes': { category: 'Bedroom', subcategory: 'Wadrobes' },
  '/Phones': { category: 'Electricals', subcategory: 'Phones' },
  '/Microwaves': { category: 'Kitchen', subcategory: 'Microwaves' },
  '/Sofas': { category: 'Lounge', subcategory: 'Sofas' },
  '/PlasmaStands': { category: 'Lounge', subcategory: 'PlasmaStands' },
  '/Plasmastands': { category: 'Lounge', subcategory: 'PlasmaStands' },
  '/Swivelchairs': { category: 'Office', subcategory: 'Swivelchairs' },
  '/Visitorschairs': { category: 'Office', subcategory: 'Visitorschairs' },
};

export const buildStorePath = ({ category, subcategory } = {}) => {
  const params = new URLSearchParams();
  if (category) params.set('category', category);
  if (subcategory) params.set('subcategory', subcategory);
  const qs = params.toString();
  return qs ? `/store?${qs}` : '/store';
};
